import React, { Component } from "react"
import * as helpers from "../../helpers/sectionclasses"
import Image from "gatsby-image"
import InView from "react-intersection-observer"
import { motion } from "framer-motion"
import { useStaticQuery, graphql } from "gatsby"

const ContactDetails = ({ content }) => {
  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          globalOptions {
            globalSiteOptions {
              googleMapLink
              email
              phoneNumber
              socialHandles {
                link
                title
              }
            }
          }
        }
      }
    `
  )

  const sectionClasses = helpers.sectionClasses(content.sectionOptions)
  return (
    <section className={`${sectionClasses}`}>
      <div className="container">
        <div className="flex pb-20">
          <div className="lrg:px-6 tab:w-9/12">
            <p className="text-md">Our deets</p>
          </div>
        </div>
        <div className="lrg:flex pb-20">
          <div className="pb-6 lrg:pb-0 lrg:px-6 tab:w-4/12">
            <p className="text-base">
              <a
                href={`tel:${wp.globalOptions.globalSiteOptions?.phoneNumber}`}
              >
                {wp.globalOptions.globalSiteOptions?.phoneNumber}
              </a>
              <br />
               
              <a href={`mailto: ${wp.globalOptions.globalSiteOptions?.email}`}>
                {wp.globalOptions.globalSiteOptions?.email}
              </a>
            </p>
          </div>
          <div className="pb-6 lrg:pb-0 lrg:px-6 tab:w-3/12">
            <p className="text-base">
              Standby Productions 
              <br />
              Studio 3G, Beehive Mill Jersey St, Ancoats, Manchester M4 6JG
              <br />
              <a href={wp.globalOptions.globalSiteOptions?.googleMapLink}>
                Google map
              </a>
            </p>
          </div>
          <div className="pb-6 lrg:pb-0 lrg:px-6 tab:w-3/12 tab:ml-20">
            <p className="text-base">
              {wp.globalOptions.globalSiteOptions?.socialHandles
                ? wp.globalOptions.globalSiteOptions.socialHandles.map(
                    (handle, index) => {
                      return (
                        <a
                          key={index} // Add a unique key
                          href={handle.link}
                          rel="noreferrer"
                          target="_blank"
                          className="block"
                        >
                          {handle.title}
                        </a>
                      )
                    }
                  )
                : ""}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactDetails
